export enum MonthEnum {
  Invalid = 0,
  January = 1,
  February = 2,
  March = 3,
  April = 4,
  May = 5,
  June = 6,
  July = 7,
  August = 8,
  September = 9,
  October = 10,
  November = 11,
  December = 12
}

export const MonthEnumMapping: Record<MonthEnum, string> = {
  [MonthEnum.Invalid]: 'Invalid',
  [MonthEnum.January]: 'January',
  [MonthEnum.February]: 'February',
  [MonthEnum.March]: 'March',
  [MonthEnum.April]: 'April',
  [MonthEnum.May]: 'May',
  [MonthEnum.June]: 'June',
  [MonthEnum.July]: 'July',
  [MonthEnum.August]: 'August',
  [MonthEnum.September]: 'September',
  [MonthEnum.October]: 'October',
  [MonthEnum.November]: 'November',
  [MonthEnum.December]: 'December'
};

export const MonthAbbrEnumMapping: Record<MonthEnum, string> = {
  [MonthEnum.Invalid]: 'Invalid',
  [MonthEnum.January]: 'Jan',
  [MonthEnum.February]: 'Feb',
  [MonthEnum.March]: 'Mar',
  [MonthEnum.April]: 'Apr',
  [MonthEnum.May]: 'May',
  [MonthEnum.June]: 'June',
  [MonthEnum.July]: 'July',
  [MonthEnum.August]: 'Aug',
  [MonthEnum.September]: 'Sept',
  [MonthEnum.October]: 'Oct',
  [MonthEnum.November]: 'Nov',
  [MonthEnum.December]: 'Dec'
};
